import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Avatar, Space } from 'antd';
import { KEYS_DAYS_IN_WEEK } from 'configs/localData';
import { RequiredDaysStyles } from 'containers/Applications/components/Primatives/ApplicationItem/styles';

const RequiredDays = ({ requiredDays }) => {
  const getClassActive = (value) => {
    const isActiveDays = !!requiredDays?.find((item) => item?.day === value);
    return isActiveDays ? 'avatar-active' : 'avatar-disabled ';
  };
  return (
    <RequiredDaysStyles isCheckColor>
      <Space size={6} align="centre">
        {KEYS_DAYS_IN_WEEK.map((item, index) => (
          <Avatar
            key={String(index)}
            className={`day-item ${getClassActive(item.value)}`}
          >
            {i18next.t(item.text)}
          </Avatar>
        ))}
      </Space>
    </RequiredDaysStyles>
  );
};

RequiredDays.propTypes = {
  requiredDays: PropTypes.array,
};

RequiredDays.defaultProps = {
  requiredDays: [],
};

export default RequiredDays;
